import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AppService } from '@core/services/app.service';
import { ModalController } from '@ionic/angular';
import { ITalepler } from '@models/dashboard';

@Component({
  selector: 'app-demands-detail',
  templateUrl: './demands-detail.component.html',
  styleUrls: ['./demands-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemandsDetailComponent implements OnInit {
  @Input() talep: ITalepler;
  
  constructor(
    public app: AppService,
    private modalController: ModalController
  ) { }

  ngOnInit(): void {
  }

  async dismiss(dismissed: boolean) {
    await this.modalController.dismiss(dismissed);
  }
}
